__turbopack_context__.v({
  "MC_AEM_Wrapper": "index-module__SxnO7W__MC_AEM_Wrapper",
  "MC_Bg_Inherit": "index-module__SxnO7W__MC_Bg_Inherit",
  "MC_Button": "index-module__SxnO7W__MC_Button",
  "MC_Carousel": "index-module__SxnO7W__MC_Carousel",
  "MC_CarouselD": "index-module__SxnO7W__MC_CarouselD",
  "MC_Carousel_header": "index-module__SxnO7W__MC_Carousel_header",
  "MC_Carousel_thumbs_slide": "index-module__SxnO7W__MC_Carousel_thumbs_slide",
  "MC_Carousel_thumbs_wrapper": "index-module__SxnO7W__MC_Carousel_thumbs_wrapper",
  "MC_Carousel_track": "index-module__SxnO7W__MC_Carousel_track",
  "MC_Carousel_track_slide": "index-module__SxnO7W__MC_Carousel_track_slide",
  "MC_Carousel_track_slide__active": "index-module__SxnO7W__MC_Carousel_track_slide__active",
  "MC_Carousel_track_slide_media": "index-module__SxnO7W__MC_Carousel_track_slide_media",
  "MC_Carousel_track_slide_media_img": "index-module__SxnO7W__MC_Carousel_track_slide_media_img",
  "MC_Carousel_track_wrapper": "index-module__SxnO7W__MC_Carousel_track_wrapper",
  "MC_Core_HeadingStyle": "index-module__SxnO7W__MC_Core_HeadingStyle",
  "MC_Heading_1": "index-module__SxnO7W__MC_Heading_1",
  "MC_Layout_Article": "index-module__SxnO7W__MC_Layout_Article",
  "MC_Link_Accent": "index-module__SxnO7W__MC_Link_Accent",
  "MC_Link_Style_RichText": "index-module__SxnO7W__MC_Link_Style_RichText",
  "MC_Theme_Core": "index-module__SxnO7W__MC_Theme_Core",
  "MC_Theme_Dungeons": "index-module__SxnO7W__MC_Theme_Dungeons",
  "MC_Theme_Legends": "index-module__SxnO7W__MC_Theme_Legends",
  "MC_Theme_Marketplace": "index-module__SxnO7W__MC_Theme_Marketplace",
  "MC_Theme_Realms": "index-module__SxnO7W__MC_Theme_Realms",
  "MC_Theme_Vanilla": "index-module__SxnO7W__MC_Theme_Vanilla",
  "MC_articleGridA": "index-module__SxnO7W__MC_articleGridA",
  "MC_articleGridA_sectionRef": "index-module__SxnO7W__MC_articleGridA_sectionRef",
  "MC_articleHeroA_header_container": "index-module__SxnO7W__MC_articleHeroA_header_container",
  "MC_articleHeroA_header_subheadline": "index-module__SxnO7W__MC_articleHeroA_header_subheadline",
  "actionBlock": "index-module__SxnO7W__actionBlock",
  "alignItemsCenter": "index-module__SxnO7W__alignItemsCenter",
  "btn": "index-module__SxnO7W__btn",
  "btnPrimary": "index-module__SxnO7W__btnPrimary",
  "c-copyright": "index-module__SxnO7W__c-copyright",
  "cCopyright": "index-module__SxnO7W__cCopyright",
  "cMobileControls": "index-module__SxnO7W__cMobileControls",
  "cMobileControls__icon": "index-module__SxnO7W__cMobileControls__icon",
  "childrenSpaced": "index-module__SxnO7W__childrenSpaced",
  "col12": "index-module__SxnO7W__col12",
  "col4": "index-module__SxnO7W__col4",
  "col6": "index-module__SxnO7W__col6",
  "colMd4": "index-module__SxnO7W__colMd4",
  "container": "index-module__SxnO7W__container",
  "containerFluid": "index-module__SxnO7W__containerFluid",
  "containerLg": "index-module__SxnO7W__containerLg",
  "containerMd": "index-module__SxnO7W__containerMd",
  "containerSm": "index-module__SxnO7W__containerSm",
  "containerXl": "index-module__SxnO7W__containerXl",
  "containerXxl": "index-module__SxnO7W__containerXxl",
  "contentGrid": "index-module__SxnO7W__contentGrid",
  "contentSection": "index-module__SxnO7W__contentSection",
  "contents": "index-module__SxnO7W__contents",
  "contentsWrapper": "index-module__SxnO7W__contentsWrapper",
  "counterWidget": "index-module__SxnO7W__counterWidget",
  "dBlock": "index-module__SxnO7W__dBlock",
  "dNone": "index-module__SxnO7W__dNone",
  "dashboardContainer": "index-module__SxnO7W__dashboardContainer",
  "dashboardHeader": "index-module__SxnO7W__dashboardHeader",
  "fadeIn": "index-module__SxnO7W__fadeIn",
  "flexNowrap": "index-module__SxnO7W__flexNowrap",
  "fullWidthSection": "index-module__SxnO7W__fullWidthSection",
  "fullWidthXs": "index-module__SxnO7W__fullWidthXs",
  "initHidden": "index-module__SxnO7W__initHidden",
  "justifyContentBetween": "index-module__SxnO7W__justifyContentBetween",
  "lContents__aside": "index-module__SxnO7W__lContents__aside",
  "lFooter": "index-module__SxnO7W__lFooter",
  "lHeader": "index-module__SxnO7W__lHeader",
  "lHeader__controls": "index-module__SxnO7W__lHeader__controls",
  "likeBadge": "index-module__SxnO7W__likeBadge",
  "listGroup": "index-module__SxnO7W__listGroup",
  "listGroupItem": "index-module__SxnO7W__listGroupItem",
  "mainTitle": "index-module__SxnO7W__mainTitle",
  "menu": "index-module__SxnO7W__menu",
  "offset1": "index-module__SxnO7W__offset1",
  "offset3": "index-module__SxnO7W__offset3",
  "pContact": "index-module__SxnO7W__pContact",
  "pContact__item": "index-module__SxnO7W__pContact__item",
  "pContact__list": "index-module__SxnO7W__pContact__list",
  "pContact__title": "index-module__SxnO7W__pContact__title",
  "pFooterNav": "index-module__SxnO7W__pFooterNav",
  "pFooterNav__item": "index-module__SxnO7W__pFooterNav__item",
  "pForBeginner": "index-module__SxnO7W__pForBeginner",
  "pForBeginner__item": "index-module__SxnO7W__pForBeginner__item",
  "pForBeginner__list": "index-module__SxnO7W__pForBeginner__list",
  "pForBeginner__title": "index-module__SxnO7W__pForBeginner__title",
  "pHotWiki__title": "index-module__SxnO7W__pHotWiki__title",
  "pLikedWiki__title": "index-module__SxnO7W__pLikedWiki__title",
  "pRecentWiki__title": "index-module__SxnO7W__pRecentWiki__title",
  "pSpNav": "index-module__SxnO7W__pSpNav",
  "pSpNav__btnClose": "index-module__SxnO7W__pSpNav__btnClose",
  "pSpNav__item": "index-module__SxnO7W__pSpNav__item",
  "pSpNav__list": "index-module__SxnO7W__pSpNav__list",
  "pSpNav__register": "index-module__SxnO7W__pSpNav__register",
  "pSpNav__title": "index-module__SxnO7W__pSpNav__title",
  "panel": "index-module__SxnO7W__panel",
  "panelBody": "index-module__SxnO7W__panelBody",
  "panelHeading": "index-module__SxnO7W__panelHeading",
  "panelSuccess": "index-module__SxnO7W__panelSuccess",
  "recentWikiList": "index-module__SxnO7W__recentWikiList",
  "recentWikiRow": "index-module__SxnO7W__recentWikiRow",
  "row": "index-module__SxnO7W__row",
  "updateTime": "index-module__SxnO7W__updateTime",
  "versionBadge": "index-module__SxnO7W__versionBadge",
  "wikiCardItem": "index-module__SxnO7W__wikiCardItem",
  "wikiCardList": "index-module__SxnO7W__wikiCardList",
});
